var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapacityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3,
    stroke: "#A0072B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19L4.50229 18.9522L4.44972 19.5H5V19ZM19 19V19.5H19.5503L19.4977 18.9522L19 19ZM5 19.5H19V18.5H5V19.5ZM5.49771 19.0478C5.79374 15.9631 8.56769 13.5 12 13.5V12.5C8.09945 12.5 4.85191 15.3091 4.50229 18.9522L5.49771 19.0478ZM12 13.5C15.4323 13.5 18.2063 15.9631 18.5023 19.0478L19.4977 18.9522C19.1481 15.3091 15.9005 12.5 12 12.5V13.5Z",
    fill: "#A0072B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacityIcon);
export default __webpack_public_path__ + "static/media/capacity-icon.2395e9b676fcf75f0962d934d9811524.svg";
export { ForwardRef as ReactComponent };